import React, { useState, useEffect } from 'react'
import { MaxHitChart } from './MaxHitChart'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { useTranslations } from '@/hooks/useTranslations'
import { SearchCriteria, SearchCriteriaParams } from '@/pages/communal/statistics/components/common/searchCriteria'
import { mapBuckets } from '../common/labels'
import { HelpPopupButton } from '@/popups/helppopup/help'
import { useModal } from '@/components/modal/Modal'
import { MaxHitPopupBody } from './MaxHitPopup'

type MaxHitBoxProps = {
  services: Services
  session: CurrentSession
  criteria: SearchCriteria
  goToUserPage: (userId: string) => void
  goToMachinePage: (machineId: string) => void
}

export interface MaxHitsBucket {
  bucket: string    // ISO timestamp string
  maxHits: number
}

export interface MaxHitApiResponse {
  buckets: MaxHitsBucket[]
  forTime: string
}

export const MaxHitBox = ({ services, session, criteria, goToUserPage, goToMachinePage }: MaxHitBoxProps) => {
  const translates = useTranslations(services, session)
  const { openModal } = useModal()
  const [response, setResponse] = useState<MaxHitApiResponse | undefined>()

  useEffect(() => {
    setResponse(undefined)
    services.session
      .fetchWithToken(`/api/communal/statistics/machines/hitmaxs?${SearchCriteriaParams(criteria)}`)
      .then((r) => r.json())
      .then((data) => {
        setResponse(data)
      })
  }, [services.session, criteria])

  if (translates === undefined || !response) {
    return <div className='spinner'></div>
  }

  // Use new buckets structure for chart data
  const labels = response.buckets.map(mapBuckets)
  const dataSet = response.buckets.map(bucket => bucket.maxHits)

  return (
    <div>
      <HelpPopupButton helpKey='page.dashboard.global.box.hitmaxs.help' translates={translates} />
      <MaxHitChart labels={labels} dataSet={dataSet}
        chartTitle={translates.for('page.dashboard.global.box.hitmaxs.title')}
        dataLabel={translates.for('page.dashboard.global.box.hitmaxs.data_label')}
        onClick={(i: number) => {
          openModal((props) => MaxHitPopupBody({
            ...props,
            services,
            session,
            translates: translates,
            criteria: criteria,
            bucketFor: new Date(response.buckets[i].bucket),
            goToUserPage,
            goToMachinePage
          }))
        }} />
    </div>
  )
}